<tam-dialog class="note-dialog relationship" [opened]="opened" [dialogWidth]="dialogWidth" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">New Valid Relationship</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)">
        </smart-icon>

    </ng-template>

    <ng-template #body>
        <div class="note-content">
            <div class="flex-box">
                <div>
                    <span>Relationship Type &nbsp;&nbsp;&nbsp;&nbsp; </span>
                </div>
                <div class="k-form-field">
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" #dropDownEl [data]="relationshipTypes"
                        [(ngModel)]="relationshipType" [textField]="'name'" class="entity-type" [valueField]="'id'"
                        (selectionChange)="selectionChange($event)">
                    </kendo-dropdownlist>
                </div>

                <div class="relationshipType-name">
                    <span>Relationship Type Name </span>
                </div>
                <div>
                    <input class="tam-input" [(ngModel)]="inputRelationshipTypeName" [maxLength]="128"
                        (ngModelChange)="textChange($event)" (paste)="pasteEvent($event)" />
                </div>

            </div>

        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">

            <div>
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">Cancel</button>

                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                    (click)="createRelationShip()">Create</button>
            </div>

        </div>
    </ng-template>
</tam-dialog>